import { InsightsClient } from 'search-insights';
import { getAlgoliaApiId, getAlgoliaReadApiKey } from '../../helpers/env';
import { getCookieConsentForAlgolia } from './algoliaDataLayer';

let searchInsightsCache: InsightsClient | undefined;

export const loadSearchInsights = async () => {
  const cookieConsent = getCookieConsentForAlgolia();
  if (searchInsightsCache) {
    return searchInsightsCache;
  }
  const insights = await import(/* webpackCunkName: "search-insights" */'search-insights');
  searchInsightsCache = insights.default;
  searchInsightsCache('init', {
    appId: getAlgoliaApiId(),
    apiKey: getAlgoliaReadApiKey(),
    useCookie: cookieConsent,
  });
  return searchInsightsCache;
};
